// const origin = window.location.origin;

export const AUTH_BASE_URL =
	origin.includes('localhost') || origin.includes('127.0.0.1') || origin.includes('dev')
		? 'https://dev.auth.pi-labs.eu'
		: 'https://auth.pi-labs.eu';

export const BASE_URL =
	origin.includes('localhost') || origin.includes('127.0.0.1') || origin.includes('dev')
		? 'https://api.dev.sumo.fleetkey.pi-labs.eu'
		: 'https://api.sumo.fleetkey.pi-labs.eu';

export const HIVE_URL =
	origin.includes('localhost') || origin.includes('127.0.0.1') || origin.includes('dev')
		? 'https://dev.hive.pi-labs.eu/api'
		: 'https://hive.pi-labs.eu/api';

export const TOKEN_URL = `${AUTH_BASE_URL}/oauth2/token`;
export const REFRESH_URL = `${AUTH_BASE_URL}/oauth2/refresh`;
export const LOGOUT_URL = `${AUTH_BASE_URL}/oauth2/logout`;
export const MAX_TIMESTAMP = 8640000000000000;
